module.exports = __webpack_public_path__ + "media/fr-clic4.1eea16ef.mp3";